<template>
  <div>
    <div class="my-shop">
      <el-button type="text" class="shop-btn" @click="changeBoxStatus">我的店铺</el-button>
      <div class="shop-code-box" v-if="isShowShareBox" :class="{ 'show-box': isShowShareBox }">
        <img src="../../assets/shop-title.png" />
        <div class="shop-info">
          <div class="shop-name">{{ $store.state.shop.info.shopName }}</div>
          <div class="qr-code">
            <qr-code
              :text="`https:${V2_ROOT}/#/shop?shopId=${$store.state.shop.info.id}`"
              :size="128"
              error-level="L"
            >
            </qr-code>
          </div>
          <div class="footer">
            <el-button class="c-f" type="text" icon="el-icon-s-home" @click="linkJump"
              >进入店铺</el-button
            >
            <el-button class="c-f" type="text" icon="el-icon-share" @click="isShowShareShop = true"
              >分享店铺</el-button
            >
          </div>
        </div>
      </div>
      <div class="mask" v-if="isShowShareBox" @click="changeBoxStatus"></div>
    </div>
    <el-dialog :visible.sync="isShowShareShop" title="分享我的店铺" center>
      <el-input type="textarea" v-model="shareText" :rows="5" class="textarea"> </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="
            isShowShareShop = false
            isShowShareBox = false
          "
          >取 消</el-button
        >
        <el-button
          type="danger"
          @click="confrimDialog"
          class="shop-share-info"
          :data-clipboard-text="shareText"
        >
          确认复制
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ZM_ROOT, V2_ROOT } from '@/common/constants/'
import QrCode from 'vue-qrcode-component'
import Clipboard from 'clipboard'

export default {
  components: {
    QrCode
  },
  data() {
    return {
      isShowShareShop: false,
      V2_ROOT,
      ZM_ROOT,
      isShowShareBox: false,
      shareText: ''
    }
  },
  mounted() {},
  methods: {
    /** 修改分享的盒子 */
    changeBoxStatus() {
      this.shareText = `${this.$store.state.shop.info.shopName}开始营业拉，点击以下链接即可在线采购，找钢网店铺地址：https:${ZM_ROOT}/shop/${this.$store.state.shop.info.id}`
      this.isShowShareBox = !this.isShowShareBox
    },
    /** 链接跳转 */
    linkJump(type) {
      this.isShowShareBox = false
      window.open(`${ZM_ROOT}/shop/${this.$store.state.shop.info.id}`)
    },
    confrimDialog() {
      let clipboard = new Clipboard('.shop-share-info')
      clipboard.on('success', () => {
        this.$message.success('复制成功')
        this.isShowShareShop = false
        this.isShowShareBox = false
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        // 不支持复制
        this.$message.warning('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-shop {
  position: relative;
  .shop-btn {
    color: #999;
    font-size: 12px;
  }
  .shop-code-box {
    position: absolute;
    width: 168px;
    left: -60px;
    top: 40px;
    display: flex;
    flex-direction: column;
    z-index: 999;
    border-radius: 2px 2px 0px 2px;
    background-color: #fff;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
  }
  img {
    width: 200px;
    margin-left: -16px;
    margin-top: -15px;
  }
  .shop-info {
    width: 156px;
    margin: 0 auto;
  }
  .shop-name {
    font-size: 14px;
    font-weight: 500;
    color: rgba(234, 39, 57, 1);
    line-height: 1.4;
    width: 128px;
    text-align: center;
    margin: 0 auto;
  }
  .qr-code {
    width: 128px;
    height: 128px;
    margin: 15px auto;
  }
  .footer {
    width: 176px;
    height: 30px;
    background: rgba(235, 35, 48, 1);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.26);
    border-radius: 10px 10px 2px 2px;
    border: 1px solid rgba(190, 6, 14, 1);
    display: flex;
    align-items: center;
    margin-left: -10px;
    button {
      color: #fff;
      padding: 0;
      flex: 1;
      font-size: 12px;
      height: 20px;
      &:last-child {
        border-left: 1px solid #fff;
      }
    }
  }
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0);
    z-index: 666;
  }
  .show-box {
    animation: showbox 0.5s;
  }
}
.mt-20 {
  margin-top: 20px;
}
@keyframes showbox {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.textarea {
  display: block;
  width: 600px;
  margin: 0 auto;
}
</style>
